import * as React from 'react'
import { Outlet, useMatch, useSearchParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { sortBy } from 'lodash'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { Companies } from 'modules/core/store/collections/companies'

import { PROFESSIONALS_APP, clientsSection } from 'modules/bookkeepers/lib/amplitudeData'
import { IntegrationsSyncContextProvider } from 'modules/integrations/public'
import { PolicyPeriodsProvider } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import policyPeriodCollection from 'modules/payroll_bundle/store/collections/policyPeriods'
import { PROFESSIONALS_COMPENSATIONS_SYNC_CONFIGURATION } from 'modules/bookkeepers/pages/SyncConfiguration'

const ClientsPage = () => {
  const { navigation } = useNavigation()
  const companies = React.useRef(new Companies()).current
  /**
   * TODO: Remove when payroll-results routes is available (PAY-2040)
   */
  const [searchParams] = useSearchParams()
  const companyId = Number(searchParams.get('switchToCompanyId'))

  const { loading } = useAsyncData(
    () =>
      companies.fetch({
        data: {
          for_bookkeepers: true,
        },
      }),
    []
  )

  const sortedCompanies = sortBy(companies.models, (company) =>
    company.attributes.name.toUpperCase()
  )

  const selectableCompanies = sortedCompanies.map((company) => {
    return {
      label: company.attributes.name,
      value: company.attributes.id,
    }
  })

  /**
   * TODO: Remove companyId as default when payroll-results routes is available (PAY-2040)
   */
  const [selectedCompanyId, setSelectedCompanyId] = React.useState(
    companyId ?? selectableCompanies[0]?.value ?? null
  )

  const changeCompany = (companyId: string) => {
    setSelectedCompanyId(Number(companyId))
    trackingCompanySelection(Number(companyId))
  }

  const isPreferencesActive = !!useMatch(navigation.bookkeepers.clients.preferences.fullPath())
  const trackingCompanySelection = (companyId: number) => {
    const company = companies.find({ id: companyId })

    track(trackingEvents.bookkeeper.settings.filterCompany, {
      application: PROFESSIONALS_APP,
      company_name: company?.attributes.name,
      section: clientsSection(isPreferencesActive),
    })
  }

  if (loading)
    return (
      <Box padding="s40" width="full" alignItems="center">
        <Spinner />
      </Box>
    )

  return (
    <PolicyPeriodsProvider policyPeriodCollection={policyPeriodCollection} isBookkeeper>
      <IntegrationsSyncContextProvider
        configuration={PROFESSIONALS_COMPENSATIONS_SYNC_CONFIGURATION}
      >
        <Box width="full" background="grey000White" alignItems="center">
          <Box
            width="full"
            style={{
              maxWidth: '1440',
            }}
          >
            {!loading && (
              <Outlet
                context={{ selectedCompanyId: selectedCompanyId || selectableCompanies[0]?.value }}
              />
            )}
          </Box>
        </Box>
      </IntegrationsSyncContextProvider>
    </PolicyPeriodsProvider>
  )
}

export default ClientsPage
